export const baseURL = window.baseURL || process.env.VUE_APP_BASEURL;
window.baseURL = baseURL || process.env.VUE_APP_BASEURL;

export default {
  title: "Fe Admin",
};
